/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
/**
 * 
 * @export
 * @interface CrmIntegrationTestCreateCustomerResponse
 */
export interface CrmIntegrationTestCreateCustomerResponse {
    /**
     * 
     * @type {string}
     * @memberof CrmIntegrationTestCreateCustomerResponse
     */
    data?: string;
    /**
     * 
     * @type {number}
     * @memberof CrmIntegrationTestCreateCustomerResponse
     */
    totalRecords?: number;
    /**
     * 
     * @type {number}
     * @memberof CrmIntegrationTestCreateCustomerResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof CrmIntegrationTestCreateCustomerResponse
     */
    pages?: number;
    /**
     * 
     * @type {Array<Error>}
     * @memberof CrmIntegrationTestCreateCustomerResponse
     */
    errors?: Array<Error>;
}

/**
 * Check if a given object implements the CrmIntegrationTestCreateCustomerResponse interface.
 */
export function instanceOfCrmIntegrationTestCreateCustomerResponse(value: object): boolean {
    return true;
}

export function CrmIntegrationTestCreateCustomerResponseFromJSON(json: any): CrmIntegrationTestCreateCustomerResponse {
    return CrmIntegrationTestCreateCustomerResponseFromJSONTyped(json, false);
}

export function CrmIntegrationTestCreateCustomerResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CrmIntegrationTestCreateCustomerResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : json['data'],
        'totalRecords': json['totalRecords'] == null ? undefined : json['totalRecords'],
        'page': json['page'] == null ? undefined : json['page'],
        'pages': json['pages'] == null ? undefined : json['pages'],
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function CrmIntegrationTestCreateCustomerResponseToJSON(value?: CrmIntegrationTestCreateCustomerResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': value['data'],
        'totalRecords': value['totalRecords'],
        'page': value['page'],
        'pages': value['pages'],
        'errors': value['errors'],
    };
}

